export type AuthSessionFailureReason = 'auth-rejected' | 'network' | 'server';

export interface AuthSessionDiagnosticSignal {
  readonly reason: AuthSessionFailureReason;
  readonly trigger: string;
}

export interface AuthSessionDiagnostic extends AuthSessionDiagnosticSignal {
  readonly boundary: 'morfi-session';
  readonly online: boolean;
  readonly platform: 'react-native' | 'web';
}

export function classifySessionFailure(error: unknown): AuthSessionFailureReason {
  if (error !== null && typeof error === 'object') {
    const candidate = error as {
      readonly category?: unknown;
      readonly httpStatus?: unknown;
      readonly status?: unknown;
    };
    if (
      candidate.category === 'auth' ||
      candidate.httpStatus === 401 ||
      candidate.httpStatus === 403 ||
      candidate.status === 401 ||
      candidate.status === 403
    ) {
      return 'auth-rejected';
    }
    if (candidate.category === 'network') return 'network';
  }
  return error instanceof TypeError ? 'network' : 'server';
}

export function classifySessionStatus(status: number): AuthSessionFailureReason {
  return status === 401 || status === 403 ? 'auth-rejected' : 'server';
}
